// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTHOR = "autor";
export const COMMENT_DELETED_BECAUSE_reason = "D\u00f4vod: %(reason)s";
export const COMMENT_DELETED_BY_ADMIN = "Odpove\u010f bola odstr\u00e1nen\u00e1";
export const COMMENT_DELETED_BY_AUTHOR = "Autor odpove\u010f zmazal";
export const FORUM_CANT_SEE_ANSWER = "Pridaj s\u00fa\u0165a\u017en\u00fa odpove\u010f a uvid\u00ed\u0161 odpovede ostatn\u00fdch";
